import {
  Truck, Headset, Handshake, Wrench, PackageOpen, ShieldCheck,
  DollarSign, Clock, GraduationCap, HeartHandshake,
} from "lucide-react";

export const POSITIONS = [
  {
    key: "truck_driver_cdl_a", icon: Truck,
    title: "CDL Class A Driver",
    type: "Full-time · Contract",
    location: "Salt Lake City, UT & regional",
    payRange: "$52k – $75k /year",
    summary: "OTR & regional runs in modern trucks. Home most weekends. Predictable dispatch.",
    bullets: [
      "Valid CDL Class A with 1+ year OTR experience",
      "Clean MVR & DOT medical card",
      "Safe driving habits, on-time delivery focus",
    ],
  },
  {
    key: "truck_driver_cdl_b", icon: Truck,
    title: "CDL Class B Driver",
    type: "Full-time",
    location: "Salt Lake City, UT",
    summary: "Local truck runs across the region. Home daily. Weekly pay.",
    bullets: [
      "Valid CDL Class B (Class A also welcome)",
      "Comfortable with pallet jack + liftgate operation",
      "Excellent customer-facing communication",
    ],
  },
  {
    key: "dispatcher", icon: Headset,
    title: "Dispatcher",
    type: "Full-time",
    location: "Salt Lake City, UT (office)",
    payRange: "$45k – $60k /year",
    summary: "Own driver assignments, ETAs, and customer comms. Fast-paced dispatch desk.",
    bullets: [
      "1+ year dispatch or logistics coordination experience",
      "Strong multitasking + calm under pressure",
      "Familiar with TMS / GPS platforms",
    ],
  },
  {
    key: "freight_broker", icon: Handshake,
    title: "Freight Broker",
    type: "Full-time · Commission",
    location: "Remote or Salt Lake City, UT",
    payRange: "Base + Commission",
    summary: "Build a book of shipper relationships and match loads across our carrier network.",
    bullets: [
      "2+ years brokerage or logistics sales experience",
      "Proven ability to build and retain accounts",
      "Comfortable with rate negotiation & margin management",
    ],
  },
  {
    key: "warehouse_associate", icon: PackageOpen,
    title: "Warehouse Associate",
    type: "Full-time · Part-time",
    location: "Salt Lake City, UT",
    payRange: "$18 – $22 /hour",
    summary: "Load, unload, and stage freight. Support drivers and dispatch with a safety-first mindset.",
    bullets: [
      "Ability to lift 50+ lbs repeatedly",
      "Forklift certification a plus (not required)",
      "Reliable and detail-oriented",
    ],
  },
  {
    key: "fleet_technician", icon: Wrench,
    title: "Fleet Maintenance Technician",
    type: "Full-time",
    location: "Salt Lake City, UT",
    payRange: "$25 – $34 /hour",
    summary: "Keep our truck fleet inspected, PM'd, and road-ready.",
    bullets: [
      "2+ years commercial vehicle maintenance experience",
      "Working knowledge of DOT compliance & inspections",
      "Own basic hand tools",
    ],
  },
  {
    key: "safety_compliance", icon: ShieldCheck,
    title: "Safety & Compliance Officer",
    type: "Full-time",
    location: "Salt Lake City, UT",
    payRange: "$55k – $75k /year",
    summary: "Own driver logs, audits, incident response, and DOT regulatory adherence.",
    bullets: [
      "3+ years FMCSA / DOT compliance experience",
      "Strong knowledge of HOS, ELD, and DVIR",
      "Sharp attention to detail & documentation",
    ],
  },
];

export const PERKS = [
  { icon: DollarSign, label: "Competitive Pay", desc: "Above-market rates, weekly pay, driver bonuses." },
  { icon: Clock, label: "Predictable Home Time", desc: "Local + regional lanes with reliable schedules." },
  { icon: GraduationCap, label: "Paid Training", desc: "Ride-alongs, safety training, ELD & DOT refreshers." },
  { icon: HeartHandshake, label: "A Real Team", desc: "Family-run operation. Every hire matters." },
];
